import {
  DiscoveryStatusApi,
  DiscoveryApi,
  type Configuration,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/discovery';

export const discovery = (
  httpClient: HttpClient,
  config: Configuration,
  projectId: string
) => {
  const discoveryApi = new DiscoveryApi(config);
  const discoveryStatusApi = new DiscoveryStatusApi(config);

  return {
    invoke: (cloudAccountId: string) =>
      discoveryApi.invokeDiscover(projectId, cloudAccountId, {}),
    useStatus: (
      cloudAccountId: string,
      options?: { refreshInterval: number }
    ) =>
      httpClient.executeWithConfig(
        discoveryStatusApi.discoveryStatus.bind(discoveryStatusApi),
        baseUrl,
        '/status',
        options ?? {},
        projectId,
        cloudAccountId
      ),
  };
};
